import { Box } from '@mui/material';

import PhoneFrame from '@/designs-dev/device/PhoneFrame';

// James's starting point: a blank phone, nothing in it yet. The screen is an
// empty surface on the app background — build the prototype out from here.
const BlankDevice = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: 'custom.neutral.100',
      p: 4,
    }}
  >
    <PhoneFrame>
      <Box sx={{ height: '100%', bgcolor: 'background.default' }} />
    </PhoneFrame>
  </Box>
);

export default BlankDevice;
